import { Loading } from 'element-ui';

export const loading = (text) => {
    return Loading.service({
        lock: true,
        text: text || '数据正在处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
};